import React, { FC } from 'react';
import { Route, Switch } from 'react-router';

import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { NotFound404Page } from 'src/common/pages/not-found-404-page/NotFound404Page';
import { TableStateProvider } from 'src/common/providers/dashboard/TableStateProvider';

import { DashboardBusinessUnits } from '../pages/business-units/DashboardBusinessUnits';
import { AccessibilityDashboard } from '../pages/dashboard/Dashboard';
import IssuesPage from '../pages/issues/IssuesPage';

const UNIT_ID_KEY = ':unitId';

export const DashboardRouter: FC = () => {
	return (
		<TableStateProvider>
			<Switch>
				<Route
					exact
					path={RoutesHelper.getAccessibilityDashboardPath()}
					component={AccessibilityDashboard}
				/>
				<Route exact path={RoutesHelper.getDashboardIssuesPath()} component={IssuesPage} />
				<Route
					exact
					path={RoutesHelper.getBusinessUnitDashboardPath()}
					component={DashboardBusinessUnits}
				/>
				<Route
					path={RoutesHelper.getBusinessUnitDashboardPath(UNIT_ID_KEY)}
					component={DashboardBusinessUnits}
				/>
				<Route render={() => <NotFound404Page />} />
			</Switch>
		</TableStateProvider>
	);
};
